/**
 * External dependencies
 */

/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT dependencies
 */

import { closeButtonIcon, filterIcon } from '../../img/icons';

/**
 * DWT components
 */

import Breadcrumbs from '../Breadcrumbs';
import Sort from '../Sort/Sort';
import FilterHeading from './FilterHeading';
import FilterNav from './FilterNav';
import FilterOptions from './FilterOptions';

const FilterRenderer = ({ filterType, data, manager, context, recordCount, error, setStart }) => {
  const { filterData, navDataSource, currentPostType, postTitle } = data;
  const {
    // UI state
    isOpen,
    isDesktop,
    noMenu,
    showBreadcrumb,
    footerIsVisible,
    // Refs
    filterRef,
    filterHeadingRef,
    breadcrumbsRef,
    // Event handlers
    openMobileFilterMenu,
    closeMobileFilterMenu,
    resetAllSortFilter,
    scrollToTop
  } = manager;

  return (
    <>
      {showBreadcrumb && (
        <Breadcrumbs ref={ breadcrumbsRef } context={ context } postTitle={ postTitle } seriesPost={ currentPostType === 'series' } />
      )}
      { filterType === 'api' && 
        <FilterHeading 
          context={ context } 
          postTitle={ postTitle } 
          recordCount={ recordCount } 
          error={ error } 
          ref={ filterHeadingRef } 
        />
      }
      
      {!isDesktop && !noMenu && (
        <button
          className={ `filters__btn--mobile capitalize py-15 col-span-full flex gap-15 items-center justify-center bg-black text-white rounded-[2px] mb-10 lg:hidden ${ footerIsVisible ? 'hidden' : '' } ${ breadcrumbsRef.current !== null ? 'row-start-3' : 'row-start-2' }` }
          type='button'
          onClick={ openMobileFilterMenu }
        >
          <span className='filters-icon'>{ filterIcon }</span>
          <span>{ filterType === 'api' ? 'Sort & Filter' : 'Filter' }</span>
        </button>
      )}
      
      {isDesktop && currentPostType !== 'collection' && filterType === 'api' && (
        <Sort context={ context } setStart={ setStart } scrollToTop={ scrollToTop } />
      )}
      
      {!noMenu && (
        <div ref={ filterRef } className={ `list-with-filters__filters lg:col-start-1 lg:row-start-3 ${ !isDesktop ? 'is-mobile shadow w-[90%] fixed bg-white top-0 right-0 overflow-y-scroll z-50 md:w-[337px]' : '' } ${ isOpen && !isDesktop ? 'is-open' : '' }` } style={ { height: !isDesktop ? 'calc(var(--vh, 1vh) * 100)' : 'auto' } }>
          
          {!isDesktop && (
            <>
              <div className='filters__top-bar bg-[#121212] text-white flex gap-15 p-20 items-center justify-between'>
                <div className='wrap flex gap-15 items-center'>
                  <span className='filters__btn--icon'>{ filterIcon }</span>
                  <span>{ filterType === 'api' ? 'Sort & Filter' : 'Filter' }</span>
                </div>
                <button
                  className='filters__btn-close'
                  type='button'
                  onClick={ closeMobileFilterMenu }
                >
                  { closeButtonIcon }
                </button>
              </div>
              { filterType === 'api' && (
                <Sort context={ context } setStart={ setStart } scrollToTop={ scrollToTop } />
              )}
            </>
          )}
          
          { navDataSource.length > 0 && <FilterNav data={ navDataSource } /> }
          
          <FilterOptions
            context={ { ...context, filterData } }
            currentPostType={ currentPostType }
            setStart={ setStart }
            scrollToTop={ scrollToTop }
          />
          
          {!isDesktop && (
            <div className='sticky bottom-0 bg-inherit filters__bottom-bar flex gap-15 px-30 py-20 border-t border-[#121212]'>
              <button
                className='filters__btn-close bg-[#121212] text-white w-[50%] py-[15.5px]'
                type='button'
                onClick={ closeMobileFilterMenu }
              >
                Done
              </button>
              <button
                className='text-[#121212] bg-inherit border border-[#121212] w-[50%] py-[15.5px]'
                type='button'
                onClick={ resetAllSortFilter }
              >
                Reset All
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FilterRenderer;
